import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTTicketABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_TICKET } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, NFT_TICKET);
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, NFT_TICKET);
  return contractSender;
}

async function getBalance(accountAddress, id) {
  const res = await getContractReader().methods.balanceOf(accountAddress, id).call();
  return parseInt(res);
}

async function getAllTicketBalance(accountAddress, id) {
  const [item1, item2, item3] = await getContractReader().methods.balanceOfBatch(accountAddress, id).call();
  return [item1.toString(), item2.toString(), item3.toString()];
}

async function isApprovedForAll(ownerAddress, operatorAddress, accountAddress) {
  return await getContractReader()
    .methods.isApprovedForAll(ownerAddress, operatorAddress)
    .call({ from: accountAddress });
}

async function approveForAll(dispatch, operatorAddress, accountAddress) {
  const emit = getContractSender().methods.setApprovalForAll(operatorAddress, true).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Approve");
  await emit;
}

async function transfer(dispatch, recipient, id, amount, accountAddress) {
  const emit = getContractSender()
    .methods.safeTransferFrom(accountAddress, recipient, id, amount, "0x00")
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Transfering");
  await emit;
}

export default { ABI, ADDRESS: NFT_TICKET, getBalance, getAllTicketBalance, isApprovedForAll, approveForAll, transfer };
